var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g({staticClass:"tr-button",class:[
		_vm.data.staticClass,
		_vm.data.class ],attrs:{"type":"button"}},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }